import PaygoFilterPresenter from './PaygoFilter/PaygoFilter'
import PaygoListPresenter from './PaygoList/PaygoListPresenter'

const PayGoList = {
    List: PaygoListPresenter,
    Filter: PaygoFilterPresenter
}

export default PayGoList